import React from 'react';
import { StyleSheet, css } from 'aphrodite-jss';
var styles = StyleSheet.create({
  container: {
    height: 'auto'
  }
});

var Container = function Container(_ref) {
  var children = _ref.children;
  return React.createElement("div", {
    className: css(styles.container),
    "data-element": "container",
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, children);
};

export default Container;